// @ts-nocheck
import React from "react";
import {
  List,
  Datagrid,
  TopToolbar,
  sanitizeListRestProps,
  TextField,
  Pagination,
  DateField,
  FilterButton,
  FunctionField,
  SelectInput,
  Button,
  TextInput,
  useListContext,
  Confirm,
  useCreate,
} from "react-admin";
import { useNavigate } from "react-router-dom";
import { Paper, Typography } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import mbaas from "../../../src/provider/Mbaas";
import { useDispatch } from "react-redux";
import { setCoinTransferFilter } from "../../slices/coinTransferPage/filterCoinTransferSlice";
import { endOfToday, startOfToday, subMonths, format } from "date-fns";
import { omit } from "lodash";
import { DateRange } from "../DateRange";

const ListActions = (props) => {
  const {
    className,
    exporter,
    filters,
    maxResults,
    CoinFilter,
    navigate,
    ...rest
  } = props;
  const [userData, setUserData] = React.useState({});
  const [open, setOpen] = React.useState(false);

  const getUserData = async () => {
    const res = await mbaas.client.user.get();
    if (res.data) {
      setUserData(res.data);
    }
    if (res.error) {
      // @ts-ignore
      notify(res.error);
    }
  };

  React.useEffect(() => {
    getUserData();
  }, []);

  // -- export button
  const ExportButton = () => {
    const { filterValues } = useListContext();
    const type_name = "transfer-balance";
    const gen_file_name = `${type_name}_${format(
      new Date(endOfToday()),
      "yyyy-MM-dd"
    )}`;

    const [exportData] = useCreate("reports", {
      data: {
        author_id: userData?.id,
        type: type_name,
        status: "queued",
        data: {
          filter: {
            ...omit(filterValues, ["status"]),
            ...(filterValues.status === "FAILED" && {
              dateLte: "1997-05-17T17:00:00.000Z",
            }),
          },
          metadata: {
            generated_filename: gen_file_name,
          },
        },
      },
    });

    const handleOnClick = () => {
      exportData();
      setOpen(true);
    };

    const navigateToReportPage = () => {
      navigate(encodeURI(`/reports?filter={"type":"transfer-balance"}`));
    };
    const ConfirmDialogContent = () => {
      return (
        <Paper elevation={0}>
          <Typography variant="body1" gutterBottom>
            Your file is exported as "{gen_file_name}.csv", to view the progress
            please visit report page below
          </Typography>
        </Paper>
      );
    };

    return (
      <Button label="Export" onClick={() => handleOnClick()}>
        <GetAppIcon />
        <Confirm
          isOpen={open}
          title="Dear User,"
          content={<ConfirmDialogContent />}
          onClose={() => setOpen(false)}
          confirm="Go To Report"
          onConfirm={navigateToReportPage}
        />
      </Button>
    );
  };

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <FilterButton filters={CoinFilter} />
      <ExportButton />
    </TopToolbar>
  );
};

const CoinTransferPagination = () => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
);

export const CoinTransferList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const CoinFilter = [
    <DateRange alwaysOn />,
    <SelectInput
      source="status"
      label="Status"
      choices={[
        { id: "SUCCESS", name: "SUCCESS" },
        { id: "FAILED", name: "FAILED" },
      ]}
      alwaysOn
      data-testid="search-status"
      onChange={(e) =>
        dispatch(setCoinTransferFilter({ status: e.target.value }))
      }
    />,

    <TextInput
      source="name"
      label="Name"
      onChange={(e) =>
        dispatch(setCoinTransferFilter({ name: e.target.value }))
      }
      alwaysOn
    />,
    <TextInput
      source="phone"
      label="MSISDN"
      onChange={(e) =>
        dispatch(setCoinTransferFilter({ phone: e.target.value }))
      }
    />,
    <TextInput
      source="target"
      label="Target"
      onChange={(e) =>
        dispatch(setCoinTransferFilter({ target: e.target.value }))
      }
    />,
    <TextInput
      source="orderId"
      label="Order ID"
      onChange={(e) =>
        dispatch(setCoinTransferFilter({ orderId: e.target.value }))
      }
    />,
  ];

  return (
    <>
      <List
        resource="coinTransfers"
        title="Consumptions &rsaquo; Coin Transfer"
        filters={CoinFilter}
        filterDefaultValues={{
          dateGte: subMonths(startOfToday(), 1),
          dateLte: endOfToday(),
        }}
        sort={{ field: "created_at", order: "DESC" }}
        actions={<ListActions navigate={navigate} CoinFilter={CoinFilter} />}
        perPage={50}
        pagination={<CoinTransferPagination />}
        sx={{
          flexGrow: 1,
          transition: (theme: any) =>
            theme.transitions.create(["all"], {
              duration: theme.transitions.duration.enteringScreen,
            }),
          marginRight: 0,
        }}
      >
        <Datagrid
          bulkActionButtons={false}
          rowStyle={(record: any) => ({
            backgroundColor: record.status === "PAID" ? "#e6ffdb" : "",
          })}
        >
          <DateField source="created_at" showTime />
          <TextField
            source="wallet_id_data.user_id_data.name"
            label="Subscriber"
            sortable={false}
          />
          <TextField
            source="wallet_id_data.user_id_data.phone"
            label="Phone"
            sortable={false}
          />
          <TextField source="debit" label="Amount" sortable={false} />
          <FunctionField
            label="Target"
            source="remark"
            sortable={false}
            render={(record) => {
              const arrRemark: string[] = record?.remark.split(" ") || [];
              const index = arrRemark?.indexOf("to");
              if (index !== -1) {
                const target = arrRemark[index + 1];
                return <label>{target}</label>;
              }
              return <label>-</label>;
            }}
          />
          <TextField
            source="transfer_balance_id"
            label="Order ID"
            sortable={false}
          />
          <FunctionField
            sortable={false}
            label="Status"
            source="status"
            render={(record) => <label>SUCCESS</label>}
          />
        </Datagrid>
      </List>
    </>
  );
};
